export default __webpack_public_path__ + "static/media/icon_CME.3ebc34b0.svg";